import axios from 'axios';

const cloudinaryAxios = axios.create({
  withCredentials: false, // Cloudinary doesn't need cookies
});

export default cloudinaryAxios;
